// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import httpRequest from '@/server/http-api'
import zqhttpRequest from '@/server/zqhttp-api'
import store from './store'
import router from './router'
import filter from '@/filter/filter'
import $ from 'jquery'
import autorem from '@/utils/autorem'
import moment from 'moment'
import { openApp } from '@/utils/skipapp'

import '@/../static/css/reset.css' /*引入公共样式-重置文件*/
import '@/../static/css/global.css' /*引入公共样式-全局样式*/
import '@/../static/css/showUI.css' /*引入公共样式-动画类库*/
import '@/../static/css/text_html.css' /*引入公共样式-富文本重置样式*/
import '@/../static/css/swiper-4.1.0.min.css' /*引入swiper样式*/

import '@/utils/skipapp.js'
import '@/../static/js/swiper-4.1.0.min.js'

window.jQuery = $;
window.$ = $;

Vue.use(Vuex)
Vue.prototype.$store = store
Vue.config.productionTip = false
Vue.prototype.$client = httpRequest
Vue.prototype.$zqclient = zqhttpRequest
Vue.prototype.$openApp = openApp

Vue.filter('dateformat', function (dataStr, pattern = 'MM月DD日 HH:mm', ) {
  return moment(dataStr * 1000).format(pattern)
})
Vue.filter('filterDateformat', function(dataStr,format) {
  return moment(dataStr * 1000).format(format)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js